document.addEventListener("DOMContentLoaded", () => {
  const toggle = document.querySelector(".menu-toggle");
  const menu = document.querySelector("#MobileMenu");
  if (toggle && menu) {
    toggle.addEventListener("click", () => {
      const isOpen = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", String(!isOpen));
      menu.hidden = isOpen;
    });
  }

  const drawer = document.querySelector("#CartDrawer");
  const drawerBody = drawer?.querySelector("[data-cart-body]");
  const drawerFooter = drawer?.querySelector("[data-cart-footer]");
  const drawerDescription = drawer?.querySelector("[data-cart-description]");
  const drawerSubtotal = drawer?.querySelector("[data-cart-subtotal]");
  const cartRoot = normalizeRoot(drawer?.getAttribute("data-cart-root"));
  const currency = drawer?.getAttribute("data-currency") || "USD";

  const setCartCount = (count) => {
    document.querySelectorAll("[data-cart-count], .cart-count").forEach((element) => {
      element.textContent = String(count);
    });
  };

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency,
      }).format(Number(cents || 0) / 100);
    } catch {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const escapeHtml = (value) =>
    String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const getCart = async () => {
    const response = await fetch(`${cartRoot}cart.js`, {
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error("Unable to load cart");
    return response.json();
  };

  const renderCart = (cart) => {
    if (!drawer || !drawerBody || !drawerFooter) return;
    setCartCount(cart.item_count);
    const hasItems = cart.items.length > 0;
    drawerFooter.hidden = !hasItems;
    drawerDescription.textContent = hasItems
      ? "Free shipping over $75."
      : "Nothing here yet.";

    if (!hasItems) {
      drawerBody.innerHTML = `
        <div class="cart-drawer-empty">
          <p>Your cart is empty.</p>
          <a class="button button-secondary" href="${cartRoot}collections/all">Browse gadgets</a>
        </div>
      `;
      return;
    }

    drawerBody.innerHTML = cart.items
      .map(
        (item) => `
          <article class="cart-drawer-item">
            <a class="cart-drawer-item-image" href="${escapeHtml(item.url)}">
              ${
                item.image
                  ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">`
                  : ""
              }
            </a>
            <div class="cart-drawer-item-info">
              <a class="cart-drawer-item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
              ${item.variant_title && item.variant_title !== "Default Title" ? `<p class="cart-drawer-item-variant">${escapeHtml(item.variant_title)}</p>` : ""}
              <p class="cart-drawer-item-price">${formatMoney(item.final_line_price)}</p>
              <div class="cart-drawer-quantity">
                <button type="button" data-cart-decrease="${escapeHtml(item.key)}" aria-label="Decrease quantity">−</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-increase="${escapeHtml(item.key)}" aria-label="Increase quantity">+</button>
                <button type="button" class="cart-drawer-remove" data-cart-remove="${escapeHtml(item.key)}">Remove</button>
              </div>
            </div>
          </article>
        `,
      )
      .join("");

    drawerSubtotal.textContent = formatMoney(cart.total_price);
  };

  const refreshCart = async () => {
    const cart = await getCart();
    renderCart(cart);
    return cart;
  };

  const openCart = async () => {
    if (!drawer) return;
    drawer.hidden = false;
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("cart-drawer-open");
    try {
      await refreshCart();
    } catch {
      if (drawerBody) drawerBody.innerHTML = '<p class="cart-drawer-error">We could not load the cart. Please try again.</p>';
    }
  };

  const closeCart = () => {
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("cart-drawer-open");
  };

  document.querySelectorAll("[data-cart-open]").forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      openCart();
    });
  });
  document.querySelectorAll("[data-cart-close]").forEach((trigger) => {
    trigger.addEventListener("click", closeCart);
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape" && drawer && !drawer.hidden) closeCart();
  });

  drawer?.addEventListener("click", async (event) => {
    const target = event.target.closest("[data-cart-increase], [data-cart-decrease], [data-cart-remove], [data-cart-clear]");
    if (!target) return;
    target.disabled = true;
    try {
      if (target.hasAttribute("data-cart-clear")) {
        await fetch(`${cartRoot}cart/clear.js`, {
          method: "POST",
          headers: { Accept: "application/json" },
        });
      } else {
        const key = target.dataset.cartIncrease || target.dataset.cartDecrease || target.dataset.cartRemove;
        const cart = await getCart();
        const item = cart.items.find((line) => line.key === key);
        if (!item) return renderCart(cart);
        const quantity = target.hasAttribute("data-cart-remove")
          ? 0
          : item.quantity + (target.hasAttribute("data-cart-increase") ? 1 : -1);
        await fetch(`${cartRoot}cart/change.js`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: key, quantity: Math.max(0, quantity) }),
        });
      }
      await refreshCart();
    } catch {
      if (drawerBody) drawerBody.insertAdjacentHTML("afterbegin", '<p class="cart-drawer-error">Could not update the cart.</p>');
    } finally {
      target.disabled = false;
    }
  });

  document.querySelectorAll(".product-card-form, .product-form").forEach((form) => {
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      const submit = form.querySelector("button[type='submit']");
      if (!submit || submit.disabled) return;
      const formData = new FormData(form);
      const variantId = Number(formData.get("id"));
      const quantity = Math.max(1, Number(formData.get("quantity") || 1));
      if (!variantId) return;
      const originalLabel = submit.textContent.trim();
      submit.disabled = true;
      submit.textContent = "Adding…";
      try {
        const response = await fetch(`${cartRoot}cart/add.js`, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ items: [{ id: variantId, quantity }] }),
        });
        if (!response.ok) {
          const error = await response.json().catch(() => null);
          throw new Error(error?.description || "Unable to add item");
        }
        await openCart();
        submit.textContent = "Added";
        window.setTimeout(() => {
          submit.textContent = originalLabel;
          submit.disabled = false;
        }, 1000);
      } catch {
        submit.textContent = "Try again";
        submit.disabled = false;
      }
    });
  });

  document.querySelectorAll("[data-quantity-decrease], [data-quantity-increase]").forEach((button) => {
    button.addEventListener("click", () => {
      const input = button.closest(".product-form")?.querySelector("[data-quantity-input]");
      if (!input) return;
      const current = Math.max(1, Number.parseInt(input.value, 10) || 1);
      const next = button.hasAttribute("data-quantity-increase") ? current + 1 : current - 1;
      input.value = String(Math.max(1, next));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  });
});

function normalizeRoot(value) {
  if (!value || value === "/") return "/";
  return value.endsWith("/") ? value : `${value}/`;
}
